import React from 'react';
import * as _ from 'lodash';
import { FieldContractorUserService } from '../../../services/FieldContractorUsers';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { messageUtility } from '../../../utilities/messageUtility';
import { FormElement, FormDropdownRadio } from '../../CommonFormComponents';

import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { ClearIcon } from '../../icons/ClearIcon';

export class FieldContractorUserDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      loaded: false,
      allLoaded: false,
      initializeLoaded: false, // 編集画面用初回ロードフラグ
      opened: false,
      fieldTreeId: null,
      jobId: null,
      options: [],
      error: '',
      condition: {
        name: '',
      },
      offset: 0,
      selected: null, // 選択協力会社情報(id)
      selectedName: '', // 選択協力会社情報(name)
      temporarySelected: null, // 選択協力会社情報temp(id)
      temporarySelectedName: '', // 選択協力会社情報temp(id)
      isLoading: true, // ロード中フラグ
    };

    this.id = Math.floor(Math.random() * 100000);
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.clearSelectedRow = this.clearSelectedRow.bind(this);
    this.getFieldContractorUsers = this.getFieldContractorUsers.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleInview = this.handleInview.bind(this);
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    this.getFieldContractorUsers();
  }

  componentWillReceiveProps(nextProps) {
    // 初期値が設定されていた場合はselectedへセット
    const initializeLoaded = this.state.initializeLoaded;
    if (
      nextProps.value !== this.state.selected &&
      !_.isEmpty(nextProps.name) &&
      initializeLoaded === false
    ) {
      this.setState({
        initializeLoaded: true,
        selected: nextProps.value || null,
        selectedName: nextProps.name || '',
        temporarySelected: nextProps.value || null,
        temporarySelectedName: nextProps.name || '',
      });

      this.getFieldContractorUsers();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.opened === true) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!_.isEqual(prevProps.dateToValue, this.props.dateToValue)) {
      this.setState(
        {
          options: [],
          loaded: false,
          allLoaded: false,
          isLoading: true,
        },
        () => {
          prevProps.dateToValue && this.clearSelectedRow();
          this.getFieldContractorUsers();
        }
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
    if (this.props.validate) {
      this.props.validate('manager_user_id');
    }
  };

  handleOpen = () => {
    // 初期化
    let { opened, selected, selectedName } = { ...this.state };
    if (opened === false) {
      // プルダウンを表示した際、temporarySelectedに選択済みのidを入れる
      this.setState({
        opened: true,
        loaded: true,
        temporarySelected: selected,
        temporarySelectedName: selectedName,
      });
    } else {
      this.setState({ opened: false }, () => {
        if (this.props.validate) {
          this.props.validate('manager_user_id');
        }
      });
    }
  };

  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition });

    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.search();
    }, 1000);
  };

  search = () => {
    this.setState(
      {
        options: [],
        loaded: false,
        allLoaded: false,
        isLoading: true,
      },
      () => {
        this.getFieldContractorUsers();
      }
    );
  };

  handleInview(notify) {
    if (this.state.loaded && !this.state.allLoaded) {
      this.setState({
        loaded: false,
      });
      this.getFieldContractorUsers(notify);
    } else if (this.state.allLoaded) {
      notify();
    }
  }

  handleSelectedRow = (id, checked) => {
    let { temporarySelected, temporarySelectedName } = { ...this.state };
    if (checked === true) {
      // 選択済みのselectedRowへ
      temporarySelected = id;
      const selectedRow = _.find(this.state.options, { user_id: id });
      // 選択した名前をtempへ
      temporarySelectedName = selectedRow.user_name;
    } else {
      temporarySelected = null;
      temporarySelectedName = '';
    }
    this.setState(
      {
        temporarySelected,
        temporarySelectedName,
      },
      () => {
        this.setValue();
      }
    );
  };

  clearSelectedRow = () => {
    this.setState({ selected: null, selectedName: '', opened: false }, () => {
      this.props.set('manager_user_id', null);
    });
  };

  setValue = () => {
    let { selected, selectedName } = { ...this.state };
    // temp情報をselect~に入れる
    selected = this.state.temporarySelected;
    selectedName = this.state.temporarySelectedName;
    this.setState({
      selected,
      selectedName,
      opened: false,
    });

    this.props.set('manager_user_id', selected);
    if (this.props.validate) {
      this.props.validate('job_id');
    }
  };

  getFieldContractorUsers(notify = () => {}) {
    const { dateToValue, isFilterByDateTo } = this.props;
    if (!dateToValue && isFilterByDateTo) {
      return;
    }
    if (this.state.loaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }
    const params = {
      field_id: this.state.fieldId,
      is_limit: 1,
      limit: 30,
      offset: _.size(this.state.options),
      name: this.state.condition.name,
      block_flag: 0,
      date_to: this.props.dateToValue,
    };

    FieldContractorUserService.list(this.state.fieldId, params).then(
      response => {
        if (response.result) {
          const fieldContractorUsers =
            response.data.entities.field_contractor_users;
          const allLoaded = _.size(fieldContractorUsers) < params.limit;
          const options = this.state.options;
          _.each(fieldContractorUsers, user => {
            if (_.findIndex(options, { user_id: user.user_id }) < 0) {
              options.push(user);
            }
          });

          this.setState({
            options,
            loaded: true,
            allLoaded,
            isLoading: false,
          });
        }
        notify();
      }
    );
  }

  render() {
    const getName = () => {
      let name = '元請担当者を選択';
      const option = _.find(this.state.options, {
        user_id: this.state.selected,
      });
      if (!_.isUndefined(option)) {
        name = option.user_name;
      } else {
        name = this.state.selectedName || name;
        if (this.props.readOnly && !this.state.selectedName) {
          name = '';
        }
      }
      return name;
    };

    if (this.props.isFormListDefault && this.props.readOnly) {
      return (
        <FormElement>
          <div>{getName()}</div>
        </FormElement>
      );
    }
    return (
      <FormElement validate={this.props.error}>
        <div className='form-dropdown dropdown-single-select'>
          {this.props.readOnly ? (
            <input disabled type='text' value={getName()} />
          ) : (
            <div ref={this.parent}>
              <div
                className={`dropdown-single-select__header ${
                  this.state.opened ? 'show' : ''
                }`}
              >
                <div
                  id='form-dropdown-btn'
                  href=''
                  className='dropdown-select'
                  onClick={this.handleOpen}
                >
                  <span className='dropdown-select__txt'>{getName()}</span>
                </div>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        defaultValue={this.state.condition.name}
                        onChange={this.setCondition}
                      />
                    </div>
                    {!this.props.useConstructionSiteCodeFlg && (
                      <div className='dropdown-single-select__item'>
                        <button
                          className='btn--sub btn--icon btn--filled'
                          onClick={this.clearSelectedRow}
                        >
                          <ClearIcon className='icon--2x' />
                          選択を解除する
                        </button>
                      </div>
                    )}
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                      >
                        <ul className='single-select'>
                          {_.map(this.state.options, (option, index) => (
                            <FormDropdownRadio
                              key={index}
                              option={option}
                              checked={
                                this.state.temporarySelected === option.user_id
                              }
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                              forId='single-field-contractor-user'
                              column='user_id'
                            >
                              {option.user_name}
                            </FormDropdownRadio>
                          ))}
                          <InfinityScrollLoad
                            targetId={this.targetId}
                            total={_.size(this.state.options)}
                            isLoading={this.state.isLoading}
                            callback={this.handleInview}
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldContractorUser.jsx